import axios from 'utils/axios';
import { put, delay } from 'redux-saga/effects';
import * as Chat from 'actions/Chat';
import { toastr } from 'react-redux-toastr'

export function* onSearchChatGroupRequest({ params, cb }) {
  try {
    const { searchValue } = params;
    const res = yield axios.get(`/api/chatGroup/searchChatGroups/${searchValue}?size=10`);
    yield put(Chat.onSearchChatGroupSuccess({ response: res }));
    console.log('res', res)
    cb && cb(null, res.data);
  } catch (e) {
    yield put(Chat.onSearchChatGroupFailure());   
    cb && cb(e); 
  }
}

export function* onGetCurrentChatGroupsRequest({ payload, cb }) {
  try {
    const res = yield axios.get(`/api/chatGroup/currentPage?size=${payload.size || 10}&page=${payload.page || 0}`);
    if (res.data) {
      const response = { list: res.data.content || [], page: payload.page || 0, size: payload.size || 20, isLastPage: res.data.last };
      yield put(Chat.onGetCurrentChatGroupsSuccess(response));
      cb && cb(res.data.content);
    }
  } catch (e) {
    yield put(Chat.onGetCurrentChatGroupsFailure({ message: e }));
  }
}

export function* onGetChatMessagesRequest({ params, cb }) {
  const { chatGroupId, size, page } = params;
  try {
    const res = yield axios.get(`/api/chatGroup/${chatGroupId}/messages?size=${size || 20}&page=${page || 0}`);
    
    console.log('SAGA (onGetChatMessagesRequest) res:', res)

    yield put(Chat.onGetChatMessagesSuccess({res: res.data||[], params}));
    if (res.data) {
      cb && cb(res.data);
    }
  } catch (e) {
    yield put(Chat.onGetChatMessagesFailure({ message: e }));
  }
}

export function* onCreateChatGroupRequest({ params, cb }) {
  try {
    const res = yield axios.post(`/api/chatGroup/create`, params);
    yield put(Chat.onCreateChatGroupSuccess(res.data || {}));
    console.log("SAGA (onCreateChatGroupRequest): ", {res, params});
    // yield put(Chat.onGetCurrentChatGroupsRequest());
    if (res.data) {
      cb && cb(res.data);
    }
  } catch (e) {
    console.log("ERROR (onCreateChatGroupRequest): ", e.toString());
    yield put(Chat.onCreateChatGroupFailure({ message: e }));
  }
}

export function* onCreateMultipleChatGroupByReqIdRequest({ params, cb }) {

  const data = new FormData();
  data.append('content', params.content);
  data.append('reqProfileId', params.reqProfileId);
  if(!!params.image) {
    data.append('file', params.image);
  }

  try {
    const res = yield axios.post(`/api/chatMessage/reqProfile`, data);
    // yield put(Chat.onCreateMultipleChatGroupByReqIdSuccess(res.data || {}));
    toastr.success('Meddelande skickat!', 'Nu är det bara vänta på svar, du hittar dom på hitChat-sidan.')
    // yield put(Chat.onGetCurrentChatGroupsRequest());
    if (res.data) {
      cb && cb(res.data);
    }
  } catch (e) {
    console.log("ERROR (onCreateChatGroupRequest): ", e.toString());
    // yield put(Chat.onCreateMultipleChatGroupByReqIdFailure({ message: e }));
  }
}

export function* onCreateMultipleChatGroupByHitClubIdRequest({ params, cb }) {

  const data = new FormData();
  data.append('content', params.content);
  data.append('hitClubId', params.hitClubId);
  if(!!params.image) {
    data.append('file', params.image);
  }

  try {
    const res = yield axios.post(`/api/chatMessage/hitClub`, data);
    toastr.success(t('toastr.onCreateMultipleChatGroupByHitClubIdRequest.title'), t('toastr.onCreateMultipleChatGroupByHitClubIdRequest.body'))
    if (res.data) {
      cb && cb(res.data);
    }
  } catch (e) {
    console.log("ERROR (onCreateChatGroupRequest): ", e.toString());
  }
}

export function* onCreateMultipleChatGroupByStudentIdRequest({ params, cb }) {

  const data = new FormData();
  data.append('content', params.content);
  if(!!params.image) {
    data.append('file', params.image);
  }
  params.studentIds.forEach(id => {
    data.append('studentIds', id);
  })

  try {
    const res = yield axios.post(`/api/chatMessage/students`, data);
    // yield put(Chat.onCreateMultipleChatGroupByReqIdSuccess(res.data || {}));
    if(params.type === "hitMember") {
      toastr.success('Meddelande skickat!')
    }
    else {
      toastr.success('Meddelande skickat!', 'Nu är det bara vänta på svar, du hittar dom på hitChat-sidan.')
    }
    // yield put(Chat.onGetCurrentChatGroupsRequest());
    if (res.data) {
      cb && cb(res.data);
    }
  } catch (e) {
    console.log("ERROR (onCreateChatGroupRequest): ", e.toString());
    // yield put(Chat.onCreateMultipleChatGroupByReqIdFailure({ message: e }));
  }
}

export function* onCreateChatMessageRequest({ params, cb }) {
  try {
    const res = yield axios.post(`/api/chatMessage/create`, params);
    yield put(Chat.onCreateChatMessageSuccess(res.data || []));
    if (res.data) {
      cb && cb(res.data);
    }
  } catch (e) {
    yield put(Chat.onCreateChatMessageFailure({ message: e }));
  }
}

export function* onPollRequest() {
  try {
    const response = yield axios.get('/api/status/poll');
    yield put(Chat.onPollSuccess(response.data || []));
  } catch (error) {
    yield put(Chat.onPollFailure({ message: error }));
  }
}

export function* onAddChatGroupParticipantsRequest({ params, cb }) {
  try {
    const { chatGroupId, chatGroupParticipants } = params;
    const res = yield axios.post(`/api/chatGroup/addChatGroupParticipants`, { chatGroupId, chatGroupParticipants });

    toastr.success('Det är roligare med fler!', 'Deltagare tillagd till chatt.')

    yield put(Chat.onAddChatGroupParticipantsSuccess(res||{}));
    cb && cb(res);
  } catch (e) {
    console.log("ERROR (onAddChatGroupParticipantsRequest): ", e.toString());
  }
};

export function* onDeleteChatGroupParticipantsRequest({ params, cb }) {
  try {
    const { chatGroupId, chatGroupParticipants, currentUserLeft } = params;
    const res = yield axios.delete(`/api/chatGroup/deleteChatGroupParticipants`, { data: { chatGroupId, chatGroupParticipants }});
    yield put(Chat.onDeleteChatGroupParticipantsSuccess({ response: res, currentUserLeft }));
    if(currentUserLeft) {
      toastr.success('Chat borttagen!', 'Lägg till en ny chat?')
    }
    else{
      toastr.success('Chatdeltager borttagen!', 'Du kan alltid lägga tillbaka om du vill!')
    }
    cb && cb(res);
  } catch (e) {
  }
};

export function* onUserTypingRequest({ params, cb }) {

  yield put(Chat.onUserTypingSuccess(params));
  yield delay(9000);
  yield put(Chat.onUserTypingDeleteRequest(params));

};

export function* onDispatchUserIsTypingRequest({ params, cb }) {
  try {
    const res = yield axios.post(`/api/chatMessage/isTyping`, params);
    yield delay(7000);
    cb && cb(res);
  } catch (e) {}
};

export function* onCreateChatMessageWithImageRequest({ params, cb }) {

  const data = new FormData();
  data.append('content', params.content);
  data.append('chatGroupId', params.chatGroup.chatGroupId);
  data.append('file', params.image);

  try {
    const res = yield axios.post(`/api/chatMessage/create2`, data);

    yield put(Chat.onCreateChatMessageWithImageSuccess({ data: res.data, params: params }));

    if (res.data) {
      cb && cb(res.data);
    }
  } catch (e) {
    console.log('onCreateChatMessageWithImageFailure', e)
    yield put(Chat.onCreateChatMessageWithImageFailure(params));
  }
}